// extracted by mini-css-extract-plugin
export default {"page":"Page_page__Bf4NV","navRight":"Page_navRight__pEFHi","search":"Page_search__b3lV5"};